<template>
  <slot :loading="loading" :disabled="disabled" :add-to-cart="submit" />
</template>

<script>
export default {
  name: "AddToCart",
};
</script>

<script setup>
import {computed} from "vue";
import {useStore} from "vuex";
import {optimisticFromProduct} from "@/utils/optimistic-line";

const store = useStore();

// Deliberately not `store.state.cart.loading`. The line is in the cart before
// this returns and the request runs behind it, so a spinner here would sit on
// the button for a round trip after the product was already added — which is
// what made adding feel slow. The slot key stays so the button templates that
// read it keep working; it simply never turns on.
const loading = computed(() => false);
const product = computed(() => store.state.product.product);
const quantity = computed(() => store.state.product.quantity);
const selectedVariant = computed(() => store.state.product.selectedVariant);
const sellingPlan = computed(() => store.state.product.sellingPlan);

// Not `loading`: a cart request in flight no longer has any bearing on whether
// this product can be added, and blocking on it made a second add wait.
const disabled = computed(() => !selectedVariant.value);

const addItem = payload => store.dispatch("cart/addItem", payload);

const submit = () => {
  if (disabled.value) return;

  const payload = {
    id: selectedVariant.value.id,
    quantity: quantity.value,
    // Lets the cart draw the row straight away instead of waiting for the add
    // to come back.
    _optimistic: optimisticFromProduct(
      product.value,
      selectedVariant.value,
      sellingPlan.value,
    ),
  };

  if (sellingPlan.value) {
    payload.selling_plan = sellingPlan.value;
  }

  addItem(payload);
};
</script>
